import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

export async function handleInsertSubcodeDocs(data: any, PermitName: string, FileType: string) {
  const formData = new FormData();
  formData.append('File', data);
  const response = await httpRequest(
    'POST',
    `/uploadPDF/document_Images?PermitName=${PermitName}&FileType=${FileType}`,
    formData, {
    'Content-Type': 'multipart/form-data'
  }
  );
  if (response?.status === 'success') {
    return response?.data
  } else {
    toast.error(response?.message);
  }
}